import * as React from 'react';
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { Skeleton } from '@mui/material';

interface BadgesSkeletonProps {
    numberOfElements: number;
    isCompactView?: boolean;
}

export function BadgesSkeleton({ numberOfElements, isCompactView = false }: BadgesSkeletonProps): React.ReactElement {
    return (
        <>
            {Array.from({ length: numberOfElements }).map((_, index) => (
                <Grid item xs={12} sm={6} md={isCompactView ? 6 : 4} key={index} container justifyContent="space-between">
                    <Grid item xs={12} container justifyContent="center">
                        <Card style={{ width: '100%' }}>
                            <Skeleton
                                variant="circular"
                                width={200}
                                height={200}
                                sx={{ margin: 'auto', padding: '16px' }}
                            />
                            <CardContent style={{ paddingTop: 0 }}>
                                <Typography variant="h6">
                                    <Skeleton width="60%" />
                                </Typography>
                                <Typography variant="body1">
                                    <Skeleton width="90%" />
                                    <Skeleton width="80%" />
                                </Typography>
                                <Typography variant="subtitle2" sx={{ mt: 1 }}>
                                    <Skeleton width="50%" />
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            ))}
        </>
    );
}